import React, { forwardRef } from "react";
import { cx } from "@emotion/css";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { Size } from "../../types/sizing";
import { StyledButton, StyledSpanContainer } from "./button.styles";
import {
    ButtonProps,
    ButtonRef,
    ButtonTypes,
    IconPosition,
} from "./button.types";

export const Button = forwardRef(
    (
        {
            children,
            type = ButtonTypes.primary,
            size = "medium",
            iconPosition = IconPosition.start,
            loading,
            icon,
            className,
            ...rest
        }: ButtonProps,
        ref: ButtonRef
    ) => {
        const ENIGMA_BUTTON_CLASS = `enigma-${ButtonTypes[type]}-button`;
        if (type == ButtonTypes.tonal) type = ButtonTypes.primary;
        if (icon) {
            icon = React.cloneElement(icon as React.ReactElement, {
                className: "enigma-button-icon",
            });
        }

        const token = useEnigmaToken();

        return (
            <StyledButton
                token={token}
                ref={ref}
                type={ButtonTypes[type]}
                size={Size[size]}
                iconPosition={iconPosition}
                loading={loading}
                icon={icon}
                className={cx(ENIGMA_BUTTON_CLASS, className)}
                {...rest}
            >
                {loading && !icon ? (
                    <StyledSpanContainer>{children}</StyledSpanContainer>
                ) : (
                    children
                )}
            </StyledButton>
        );
    }
);

Button.displayName = "Button";
